<template>
  <app-timeline v-if="data && data.length > 0">
    <app-timeline-item
      v-for="item in data"
      :key="item.id"
      icon="CalendarIcon"
      variant="primary"
    >
      <b-row
        b-type="flex"
        b-justify="space-between"
        class="pb-1"
        style="border-bottom: 1px solid #f4f4f4"
      >
        <b-col cols="9">
          <b-row
            b-type="flex"
            b-justify="space-between"
          >
            <b-col
              cols="12"
              sm="4"
              md="3"
            >
              <b-badge
                pill
                variant="light-info"
              >
                {{ item.dataHoraInicio | daysMonth }}
              </b-badge> #{{ item.id }}
            </b-col>
            <b-col
              cols="12"
              sm="4"
              md="3"
            >
              <b>{{ item.unidade && item.unidade.descricao }}</b>
            </b-col>
            <b-col
              cols="12"
              sm="4"
              md="3"
            >
              {{ item.areaComum.nome }}
            </b-col>
            <b-col
              cols="12"
              sm="4"
              md="3"
            >
              <b-badge
                pill
                variant="light-primary"
              >
                {{ item.restricao && item.restricao.descricao }}
              </b-badge>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="3"
          align="right"
        >
          <b-button
            variant="outline-primary"
            class="btn-icon rounded-circle"
            size="lg"
            :to="'/reservas/view/' + item.id"
          >
            <feather-icon icon="ArrowRightIcon" />
          </b-button>
        </b-col>
      </b-row>
    </app-timeline-item>
  </app-timeline>
</template>

<script>
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'

export default {
  name: 'ReservaTimeline',
  components: {
    AppTimeline,
    AppTimelineItem,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.reserva-timeline li:nth-child(odd) {
  border-left: 4px solid darkblue;
  background-color: #f1f1f1;
}

.reserva-timeline li:nth-child(even) {
  border-left: 4px solid lightblue;
  background-color: white;
}

.date-info {
  font-weight: bold;
}
</style>
